import {Routes} from '@angular/router';
import {OrganizationDetailComponent} from './organization-detail/organization-detail.component';
import {OrganizationModifyComponent} from './organization-modify/organization-modify.component';
import {RoleGuardService} from '../shared/services/security/role-guard.service';
import {AuthenticatedGuardService} from '../shared/services/security/authenticated-guard.service';

export const ORGANIZATION_ROUTES: Routes = [
  {path: '', redirectTo: '/contacts', pathMatch: 'full'},
  {path: ':id/detail', component: OrganizationDetailComponent},
  {
    path: ':id/modify',
    children: [
      {path: '', component: OrganizationModifyComponent},
      {path: ':stepId', component: OrganizationModifyComponent}
    ],
    canActivate: [AuthenticatedGuardService]
  },
  {
    path: 'create', component: OrganizationModifyComponent,
    canActivate: [RoleGuardService],
    data: {
      expectedRole: 'WSD_ORGANIZATION_CREATE'
    }
  }
];
